// 履歴
//
export class DbHistoryManagement {
    // 講習ID
    public courseManagementId: string;
    // 申込番号
    public applicationNumber: number;
    // 氏名（漢字）
    public name: string;
    // 氏名（ふりがな）
    public nameFurigana: string;
    // メールアドレス
    public email: string;
    // 状態
    public status: string;
    // 受講開始日時
    public from: Date | null;
    // 受講完了日時
    public to:  Date | null;

    // firebase user uid
    public uid: string;

    // user key
    public id: string;

    // 講義・分科会等N（{名称}）：申込
    public lecturesSubcommittees: string[];

    public static STATUS = {
        "NotAttended": "notattended",
        "During": "during",
        "Done": "done",
        "Expired": "expired"
    };

    constructor(){
        this.courseManagementId = "";
        this.applicationNumber = 0;
        this.name = "";
        this.nameFurigana = "";
        this.email = "";
        this.status = DbHistoryManagement.STATUS.NotAttended;
        this.from = null;
        this.to = null;
        this.uid = "";
        this.id = "";
        this.lecturesSubcommittees = [];
    }

    // コンバーター
    public static Converter = {
        toFirestore: function(src: any) {
            console.log("toFirestore", src);
            return {
                courseManagementId: src.courseManagementId,
                applicationNumber: parseInt(src.applicationNumber),
                name: src.name,
                nameFurigana: src.nameFurigana,
                email: src.email,
                status: src.status,
                from: src.from,
                to: src.to,
                uid: src.uid,
                id: src.id,
                lecturesSubcommittees: src.lecturesSubcommittees
            }
        },
        fromFirestore: function(snapshot: any, options: any){
            const data = snapshot.data(options);
            const dst = new DbHistoryManagement();
            dst.courseManagementId = data.courseManagementId;
            dst.applicationNumber = parseInt(data.applicationNumber);
            dst.name =  data.name
            dst.nameFurigana = data.nameFurigana;
            dst.email = data.email;
            dst.status = data.status;
            dst.from = data.from;
            dst.to = data.to;
            dst.uid = data.uid;
            dst.id = data.id;
            dst.lecturesSubcommittees = data.lecturesSubcommittees;
            return dst;
        }
    }
}

export class DbHistoryManagementDetail {
    // 講習ID
    public courseManagementId: string;
    // 申込番号
    public applicationNumber: number;
    // 氏名（漢字）
    public name: string;
    // 氏名（ふりがな）
    public nameFurigana: string;
    // 生年月日
    public birthday: string;
    // メールアドレス
    public email: string;
    // 講習詳細ID
    public courseManagementDetailsId: string;
    // 園（名称）
    public ainderGarten: string;
    // 園（都道府県）
    public prefectures: string;
    // 園（市区町村）
    public municipality: string;
    //分科会番号
    public subcommitteeNumber: string;
    // 章ID
    public chapterID: string;
    // 章名
    public lectureName: string;
    // 分類
    public classification: string;
    // 説明
    public description: string;
    // 動画ID
    public videoID: string;
    // 再生速度変更
    public playbackSpeedChange: string;
    // ミーティングURL
    public meetingURL: string;
    // 開始日時
    public from: Date | null;
    // 終了日時
    public to: Date | null;
    // 講義時間（分）
    public time: string;

    // 状態
    public status: string;

    // firebase user uid
    public uid: string;
    // user key
    public id: string;

    // 講義・分科会等N（{名称}）：申込
    public lecturesSubcommittees: string[];

    public static STATUS = {
        "NotAttended": "notattended",
        "During": "during",
        "Done": "done",
    };

    // コンストラクタ
    constructor(){
        this.courseManagementId = "";
        this.applicationNumber = 0;
        this.name = "";
        this.nameFurigana = "";
        this.birthday = "";
        this.email = "";
        this.courseManagementDetailsId = "";
        this.ainderGarten = "";
        this.prefectures = "";
        this.municipality = "";
        this.subcommitteeNumber = "";
        this.chapterID = "";
        this.lectureName = "";
        this.classification = "";
        this.description = "";
        this.videoID = "";
        this.playbackSpeedChange = "";
        this.meetingURL = "";
        this.from = null;
        this.to = null;
        this.time = "";
        this.status = DbHistoryManagementDetail.STATUS.NotAttended;
        this.uid = "";
        this.id = "";
        this.lecturesSubcommittees = [];
    }

    // コンバーター
    public static Converter = {
        toFirestore: function(src: any) {
            return {
                courseManagementId: src.courseManagementId,
                applicationNumber: parseInt(src.applicationNumber),
                name: src.name,
                nameFurigana: src.nameFurigana,
                birthday: src.birthday,
                email: src.email,
                courseManagementDetailsId: src.courseManagementDetailsId,
                ainderGarten: src.ainderGarten,
                prefectures: src.prefectures,
                municipality: src.municipality,
                subcommitteeNumber: src.subcommitteeNumber,
                chapterID: src.chapterID,
                lectureName: src.lectureName,
                classification: src.classification,
                description: src.description,
                videoID: src.videoID,
                playbackSpeedChange: src.playbackSpeedChange,
                meetingURL: src.meetingURL,
                from: src.from,
                to: src.to,
                time: src.time,
                status: src.status,
                uid: src.uid,
                id: src.id,
                lecturesSubcommittees: src.lecturesSubcommittees
            }
        },
        fromFirestore: function(snapshot: any, options: any){
            const data = snapshot.data(options);
            const dst = new DbHistoryManagementDetail();
            dst.courseManagementId = data.courseManagementId;
            dst.applicationNumber = parseInt(data.applicationNumber);
            dst.name =  data.name
            dst.nameFurigana = data.nameFurigana;
            dst.birthday = data.birthday;
            dst.email = data.email;
            dst.courseManagementDetailsId = data.courseManagementDetailsId;
            dst.ainderGarten = data.ainderGarten;
            dst.prefectures = data.prefectures;
            dst.municipality = data.municipality;
            dst.subcommitteeNumber = data.subcommitteeNumber;
            dst.chapterID = data.chapterID;
            dst.lectureName = data.lectureName;
            dst.classification = data.classification;
            dst.description = data.description;
            dst.videoID = data.videoID;
            dst.playbackSpeedChange = data.playbackSpeedChange;
            dst.meetingURL = data.meetingURL;
            dst.from = data.from;
            dst.to = data.to;
            dst.time = data.time;
            dst.status = data.status;
            dst.uid = data.uid;
            dst.id = data.id;
            dst.lecturesSubcommittees = data.lecturesSubcommittees;
            return dst;
        }
    }
}